module.exports = __webpack_public_path__ + "static/media/fo.98fc1290.webp";